/**
 * FreeRoundsInfoBannerUpdateData.ts
 */
export class FreeRoundsInfoBannerUpdateData {
    getScale() {
        return this.scale;
    }
    getInfoBannerType() {
        return this.infoBannerType;
    }
    getInfoBannerLocation() {
        return this.location;
    }
    setScale(scale) {
        this.scale = scale;
    }
    setInfoBannerType(type) {
        this.infoBannerType = type;
    }
    setLocation(location) {
        this.location = { x: location.x, y: location.y };
    }
    setInfoBannerColors(colors) {
        this.colors = colors;
    }
    getInfoBannerColors() {
        return this.colors;
    }
}
//# sourceMappingURL=FreeRoundsResizeUpdateData.js.map